var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    height: 32,
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.1,8.3l-8-8C18.9,0.1,18.6,0,18.3,0H6.9C5.6,0,4.6,1,4.6,2.3v27.4c0,1.3,1,2.3,2.3,2.3h18.3 c1.3,0,2.3-1,2.3-2.3V9.1C27.4,8.8,27.3,8.6,27.1,8.3z M18.3,2.7l6.4,6.4h-6.4V2.7z M25.1,29.7H6.9V2.3H16v6.9c0,1.3,1,2.3,2.3,2.3 h6.9V29.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 22.9,
    className: "st0",
    width: 13.7,
    height: 2.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 16,
    className: "st0",
    width: 13.7,
    height: 2.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.5c50cd3f.svg";
export { ForwardRef as ReactComponent };